const LINKS: { label: string; href: string }[] = [
  { label: 'Suporte', href: '/suporte' },
  { label: 'Status do sistema', href: 'https://www.cloudflarestatus.com' },
  { label: 'Termos de uso', href: 'https://ingrave.com.br/termos-de-uso' },
  { label: 'Política de privacidade', href: 'https://ingrave.com.br/politica-de-privacidade' },
];

export function AppFooter() {
  return (
    <footer className="mt-auto border-t border-kumo-line px-4 py-4 text-xs text-kumo-subtle">
      <nav aria-label="Rodapé" className="flex flex-wrap items-center gap-x-5 gap-y-2">
        {LINKS.map((l) => (
          <a
            key={l.label}
            href={l.href}
            target={l.href.startsWith('/') ? undefined : '_blank'}
            rel="noopener noreferrer"
            className="text-kumo-subtle no-underline hover:text-kumo-default hover:underline"
          >
            {l.label}
          </a>
        ))}
        <span className="ml-auto">© {new Date().getFullYear()} Ingrave Argentic</span>
      </nav>
    </footer>
  );
}
